jQuery(document).ready(function() {
  var $ = window.jQuery;
  if(window.contentItem) {
    var content = window.contentItem;

    // Basic members - recheck paywall on window focus
    var hit_paywall = content.openPaywall;
    if(!hit_paywall && !content.premium) {
      $(window).on('focus',function() {
        $.ajax({
          method: "POST",
          url: "/?__call=Auth",
          data: {
            action: 'canDownload',
            type: content.type,
            id: content.id
          }
        }).done(function (o) {
          if(o.status) {
            if(!o.allowed) {
              hit_paywall = true;

          		// google does some magic with iframes, we need to adjust the z-index
          		$('.saveGoogleDrive').empty().css('z-index', '10000');
            }
          }
        });
      });
    }


    if(content.loggedIn) {
      // Able to download answersheet, track download
      if(content.canDownloadAnswerSheet) {
        $(".answersheet-link").on('click',function(e) {
          if(window.Edu && window.Edu.trackEvent) {
            window.Edu.trackEvent('Downloaded Content',{
              contentId: content.id,
              contentType: content.type+"-answerkey",
              section: content.section,
              name: content.name
            },{
              eventCategory: content.type,
              eventAction: 'download answerkey'
            });

            if (content.source && content.order) {
              window.Edu.trackEvent('Engagement Action', {
                source: content.source,
                order: content.order,
                action: 'download'
              });
            }
          }
        });
      }
      // Not able to download answersheet, show paywall
      else {
  			(function() {
  				var answersheet_paywall_modal = jQuery("#answersheet_paywall_modal").modal({
  					onOpen: function() {
  						if(this.ga_fired) return;
  						this.ga_fired = true;

  						if(window.Edu && window.Edu.trackEvent) {
  							window.Edu.trackEvent('Hit Feature Wall',{
  								feature: 'Answer Key Download',
  								section: content.section,
  								contentType: content.type,
  								name: content.name
  							},{
  								eventCategory: content.type,
  								eventAction: 'answersheet featurewall open'
  							});

                if (content.source && content.order) {
                  window.Edu.trackEvent('Engagement Action', {
                    source: content.source,
                    order: content.order,
                    action: 'paywall'
                  });
                }
  						}
  					}
  				});

  				jQuery(".answersheet-link").on('click',function(e) {
  					// Stop the user from loading the woanswersheet
  					e.preventDefault();
  					answersheet_paywall_modal.modal('show');
  				});
  			})();
      }

      // Premium member, record download immediately
  		$('.download-link').on('click', function() {
        // Don't record the download if they've hit the paywall
        if(hit_paywall) return;

  			if(window.Edu && window.Edu.trackEvent) {
  				window.Edu.trackEvent(content.downloadEvent,{
                    contentId: content.id,
  					contentType: content.type,
  					section: content.section,
  					name: content.name,
                    button: "main",
                    eSparkLearning: content.eSparkLearning
  				},{
  					eventCategory: content.type,
  					eventAction: content.downloadGAAction,
  					eventLabel: content.downloadGALabel,
  					metric1: 1
  				});

          if (content.source && content.order) {
            window.Edu.trackEvent('Engagement Action', {
              source: content.source,
              order: content.order,
              action: 'download'
            });
          }
  			}
      });

        // Premium member, record download immediately
        $('.download-link-hover').on('click', function() {
            // Don't record the download if they've hit the paywall
            if(hit_paywall) return;

            if(window.Edu && window.Edu.trackEvent) {
                window.Edu.trackEvent(content.downloadEvent, {
                    contentId: content.id,
                    contentType: content.type,
                    section: content.section,
                    name: content.name,
                    button: "image_hover"
                },{
                    eventCategory: content.type,
                    eventAction: content.downloadGAAction,
                    eventLabel: content.downloadGALabel,
                    metric1: 1
                });

                if (content.source && content.order) {
                    window.Edu.trackEvent('Engagement Action', {
                        source: content.source,
                        order: content.order,
                        action: 'download'
                    });
                }
            }
        });

        $('.see-in-a-set').on('click', function() {

            if(window.Edu && window.Edu.trackEvent) {
                window.Edu.trackEvent(content.seeInASet,{
                    contentType: content.type,
                    section: content.section,
                    name: content.name
                },{
                    eventCategory: content.type,
                    eventAction: content.seeInASet,
                    eventLabel: content.seeInASet,
                    metric1: 1
                });

                if (content.source && content.order) {
                    window.Edu.trackEvent('Engagement Action', {
                        source: content.source,
                        order: content.order,
                    });
                }
            }
        });

      $('.lesson-plan-attachment').on('click', function() {
        // Don't record the download if they've hit the paywall
        if(hit_paywall) return;

        if(window.Edu && window.Edu.trackEvent) {
          window.Edu.trackEvent(content.downloadEvent,{
            contentId: content.id,
            contentType: "Lesson Plan Attachment",
            section: content.section,
            name: content.name
          },{
            eventCategory: content.type,
            eventAction: "download lesson plan attachment",
            eventLabel: "Lesson Plan Attachment",
            metric1: 1
          });
          if (content.source && content.order) {
            window.Edu.trackEvent('Engagement Action', {
              source: content.source,
              order: content.order,
              action: 'download'
            });
          }
        }
      });
    }

    // Hack to catch the click event when hovering over the Save to Drive button
  	var insideSGD = false;
  	$('.saveGoogleDrive').on({
  		'mouseenter': function(){
  			insideSGD = true;
  		},
  		'mouseleave': function(){
  			insideSGD = false;
  		}
  	});
  	$(window).on('blur', function(){
  		if(insideSGD) {
  			if(window.Edu && window.Edu.trackEvent) {
  				window.Edu.trackEvent(content.downloadEvent,{
  					contentType: content.type,
  					method: "google-drive",
  					section: content.section,
  					name: content.name
  				},{
  					eventCategory: content.type,
  					eventAction: 'save to drive',
  					eventLabel: content.downloadGALabel+' - Google Drive',
  					metric1: 1
  				});
  			}
  		}
  	});

    // If able to download, load the Save to Drive script
    if(content.loggedIn && !content.openPaywall) {
    }
    // Not logged in or hit paywall, show same modal as download button
    else {
    	$('.saveGoogleDrive').on('click', function () {
    		$('.download-link').eq(0).trigger('click');
    	});
    }
  }

  // Closeable category tags tooltip
  $(document).ready(function() {
    var tag_tooltip = $('.tag-holder .tooltip');
    $('i',tag_tooltip).on('click',function() {
      if(window.localStorage) window.localStorage.setItem('close-tag-tooltip-v0',true);
      tag_tooltip.removeClass('show');
    });
    if(window.localStorage && !window.localStorage.getItem('close-tag-tooltip-v0')) {
      tag_tooltip.addClass('show');
    }
  });


});
